import round from 'lodash/round';
import toNumber from 'lodash/toNumber';
import toString from 'lodash/toString';

export const toRateNumber = (
  value: string | number,
  precision?: number | undefined,
) => {
  const valueSanitized = toString(value).replace(/[^0-9.]/g, '');

  let valueAbsolute = Math.abs(toNumber(valueSanitized));

  if (valueAbsolute < 1) {
    // value is less than 1, it's a decimal, so multiply by 100 to get a percentage value
    valueAbsolute *= 100;
  }

  const valueRounded = round(valueAbsolute, precision);

  return valueRounded;
};
